import { z } from 'zod';
import type { HostKind } from '#util/host.ts';

export function checkHostNameAllowed(value: string) {
  return value.toLowerCase() !== 'any';
}

const SENTENCE_CASE_NOUN: Record<HostKind, string> = { host: 'Host', lighthouse: 'Lighthouse', relay: 'Relay' };

export const makeHostNameSchema = (kind: HostKind) => {
  const requiredError = `A name for the ${kind} must be provided`;
  return z
    .string({ required_error: requiredError })
    .min(1, requiredError)
    .max(255, `${SENTENCE_CASE_NOUN[kind]} name cannot be longer than 255 characters`)
    .refine((value: string) => checkHostNameAllowed(value), `Invalid ${kind} name`);
};

export const hostNameSchema = makeHostNameSchema('host');
